import { useItemsStore } from '@/stores/items.js'
import paginationWithStoreMixin from '@/mixins/paginationWithStoreMixin.js'
import debounce from 'lodash.debounce'
export default {
  mixins: [paginationWithStoreMixin],
  data () {
    return {
      LocalFilters: {},
      LocalFiltersDebounce: debounce(async () => {
        await this.fetchItems()
      }, 500),
      LoadingFetchingItems: false,
      LoadingDeletingItemsIds: [],
      ValidationErrorMessageFetchingItems: null,
    }
  },
  computed: {
    itemsStoreModule () {
      return useItemsStore()
    },
    items () {
      return this.itemsStoreModule.getItems
    },
    filters () {
      return {
        ...this.LocalFilters
      }
    }
  },
  methods: {
    filtersChanged(filters) {
      this.LocalFilters = filters
      /**
       * @todo There has to be a better way to do this
       */
      this.LocalFiltersDebounce()
    },
    async sortChanged (ctx) {
      console.log(ctx)
      this.itemsStoreModule.orderBy = ctx.orderBy
      this.itemsStoreModule.orderDirection = ctx.orderDirection
      await this.fetchItems()
    },
    async deleteItemById(itemId) {
      try {
        if (confirm('Are you sure you want to delete this item?')) {
          this.ValidationErrorMessage = null
          this.LoadingDeletingItemsIds.push(itemId)
          await this.itemsStoreModule.itemDelete(itemId)
          this.LoadingDeletingItemsIds = this.LoadingDeletingItemsIds.filter(id => id !== itemId)
          this.$emit('deleted', itemId)
          await this.fetchItems()
        }
      } catch (e) {
        console.error(e)
        this.LoadingDeletingItemsIds = this.LoadingDeletingItemsIds.filter(id => id !== itemId)
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async fetchNextItems(params = {}) {
      this.page++;
      await this.fetchItems({
        clear: false,
      })
    },
    async fetchItems (params = {}) {
      try {
        // console.log(this.filters, this.filters.map(item => ({ [item.field]: item.value })))
        console.log(this.filters)
        this.ValidationErrorMessageFetchingItems = null
        this.LoadingFetchingItems = true
        const response = await this.itemsStoreModule.fetchItems({
          clear: params.clear !== undefined?  params.clear : true,
          ...this.paginationParamsObject,
          ...(this.with && { with: this.with }),
          ...this.filters,
          ...params
        })
        // this.TotalRows = response.total
        this.LoadingFetchingItems = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingItems = false
        if (e.response) {
          this.ValidationErrorMessageFetchingItems = e.response.data
        }
        this.$notify(e.response.data.message, 'danger')
        throw e
      }
    }
  }
}
